export const CATEGORIES = [
  { value: 'lajme', label: 'Lajme', color: '#2563eb' },
  { value: 'politikë', label: 'Politikë', color: '#64748b' },
  { value: 'ekonomi', label: 'Ekonomi', color: '#84cc16' },
  { value: 'sport', label: 'Sport', color: '#ef4444' },
  { value: 'kulturë', label: 'Kulturë', color: '#dc2626' },
  { value: 'teknologji', label: 'Teknologji', color: '#0ea5e9' },
  { value: 'lifestyle', label: 'Lifestyle', color: '#f59e0b' },
  { value: 'shëndetësi', label: 'Shëndetësi', color: '#8b5cf6' },
];


export const POPULAR_TAGS = [
  'lajm-i-fundit',
  'ne-trend',
  'e-vecuar',
  'ekskluzive',
  'shëndetësi',
  'analizë',
  'intervistë',
  'shqyrtim',
  'si-ta-bësh',
  'udhëzues',
  'këshilla',
  'lajme',
  'përditësim',
  'njoftim',
  'ngjarje',
];

export const IMAGE_PRESETS = {
  THUMBNAIL: { width: 300, height: 200 },     
  MEDIUM: { width: 800, height: 600 },        
  LARGE: { width: 1200, height: 900 },        
  BANNER: { width: 1920, height: 600 },       
};
